import { RewardDistributionData } from 'helpers/api/rawVesta/getRewardDistributionData';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import BigNumber from 'bignumber.js';

export const RewardDistributionDataCard = ({
  selectedAddress
}: {
  selectedAddress?: string;
}) => {
  const rewardDistributionData = useSelector(
    (state: RootState) => state.rawVesta.rewardDistributionData
  );
  const [selectedFarmData, setSelectedFarmData] =
    useState<RewardDistributionData>();

  useEffect(() => {
    if (
      selectedAddress === null ||
      selectedAddress === undefined ||
      rewardDistributionData.data === null ||
      rewardDistributionData.data === undefined
    ) {
      return;
    }
    const selectedData =
      rewardDistributionData.data?.expectedRewardDistributionData?.filter(
        (d) => d.farm_address === selectedAddress
      );
    if (selectedData === undefined || selectedData.length === 0) {
      return;
    }
    setSelectedFarmData(selectedData[0]);
  }, [
    rewardDistributionData,
    rewardDistributionData.data,
    rewardDistributionData.status,
    selectedAddress
  ]);

  const dataPairComponent = (left: string, right: string | number) => {
    return (
      <div className='d-flex justify-content-between'>
        <span>{left}</span>
        <span>{right}</span>
      </div>
    );
  };
  return selectedFarmData === undefined || selectedFarmData === null ? null : (
    <div className='card'>
      <div className='card-header'>Reward distribution data</div>
      <div className='card-body'>
        {dataPairComponent(
          'Is snapshotting',
          selectedFarmData.is_snapshotting ? 'YES' : 'NO'
        )}
        {dataPairComponent(
          'Farm weight share',
          `${new BigNumber(selectedFarmData.farm_weight_share_percentage ?? '0')
            .dividedBy(new BigNumber(10).pow(16))
            .toNumber()
            .toLocaleString(undefined, {})}%`
        )}
        {dataPairComponent(
          'Raw VST estimated drop',
          new BigNumber(selectedFarmData.raw_vst_estimated_amount ?? '0')
            .dividedBy(new BigNumber(10).pow(18))
            .toNumber()
        )}
      </div>
    </div>
  );
};
